module.exports = __webpack_public_path__ + "media/images/markers/ring_marker-a203bf38592db2c57b01a4858d31845e.svg";